import { useLocalDebug } from '../store'

export const WWT_TAG = ['%c[WWT]', 'color: #10b981; font-weight: bold;']

export const wwtLog = (...messages: unknown[]) => {
	if (useLocalDebug.getState().debugMode === false) return
	// eslint-disable-next-line
	console.log(...WWT_TAG, ...messages)
}

export const wwtLogWithoutTag = (...messages: unknown[]) => {
	if (useLocalDebug.getState().debugMode === false) return
	// eslint-disable-next-line
	console.log(...messages)
}
